<template>
  <div class="flex-center">
    <v-btn color="admin" dark outlined @click="onExport">
      <v-icon left>mdi-file-excel-outline</v-icon>Xuất Excel
    </v-btn>
  </div>
</template>
<script>
import {mapActions} from 'vuex'
import * as XLSX from 'xlsx'
import {saveAs} from 'file-saver'
import {get} from 'lodash'
import moment from 'moment'

export default {
  methods: {
    ...mapActions({exportExcel: 'assignClass/exportExcel'}),
    async onExport() {
      this.$loading.active = true
      const items = await this.exportExcel({type: 'Khối 6'})
      const worksheet = XLSX.utils.json_to_sheet(
        items.map(i => ({
          'Mã hồ sơ': i.code,
          'Cơ sở': i.department,
          'Đợt đăng ký': i.retryType > 0 ? '2' : '1',
          'Tên thí sinh': i.name,
          'Điểm NN': i.examLanguage,
          'Điểm TD': i.examMathMark,
          'Tổng điểm': i.examTotal,
          'Đã xếp lớp': get(i, 'assignedClassTitle', '-chưa xếp lớp-'),
          HSNH: Object.keys(get(i, 'documentStates', {})).length > 0 ? 'Đã đánh dấu' : 'Chưa đánh dấu',
          'Rút HS': i.isWithdrawn ? 'Đã rút' : 'Chưa rút',
          'Giao dịch vào lúc': this.getTransactionTime(get(i, 'transactionTime', '')),
          'LINK Phiếu biên nhận': get(i, 'schoolFiles.invoice', ''),
          'LINK Giấy xác nhận trúng tuyển và đăng ký nhập học': get(i, 'schoolFiles.confirmation', ''),
        })),
      )
      const workbook = {Sheets: {data: worksheet}, SheetNames: ['data']}
      const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'})
      const data = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      })
      saveAs(data, 'ds-xep-lop-6.xlsx')
      this.$loading.active = false
    },
    getTransactionTime: transactionTime => (!transactionTime ? '' : moment(transactionTime).format('DD/MM/YYYY HH:mm')),
  },
}
</script>
